<template>
  <div class="AtlasFigureCaption">
    <h2 class="AtlasFigureCaption-title" v-if="breakdown.captionSubhed">
      {{ breakdown.captionSubhed }}
    </h2>
    <div class="AtlasFigureCaption-content" v-html="sanitize(caption)"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import sanitize from 'sanitize-html';

export default {
  name: 'atlas-figure-caption',

  props: {
    breakdownId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters('breakdown', ['breakdownById', 'captionByBreakdownId']),

    breakdown() {
      return this.breakdownById(this.breakdownId);
    },
    caption() {
      return this.captionByBreakdownId(this.breakdownId);
    },
  },

  methods: {
    sanitize,
  },
};
</script>

<style lang="scss">
.AtlasFigureCaption {
  // (105 + 15 + 30) - 7.5 = 142.5

  &-title {
    font-weight: bold;
    padding: 0;
    margin: 0 0 30px;
    font-size: 24px;
    line-height: 1.333333;
  }

  &-content {
    // These styles are based on the original designs for BHEA/LHEA.
    // NEA is different and is overridden on the Drupal side.
    color: #7d8ea1;
    font-weight: 700;

    h3 {
      margin: 0 0 5px;
      font-size: 60px;
      font-weight: normal;
      line-height: 1;
    }

    p {
      margin: 0 0 30px;
      font-size: 18px;
      line-height: 1.555556;
    }
  }
}
</style>
